import React, { useMemo } from 'react'
import { useParams } from 'react-router-dom'
import DetailWrapper from '../../../sharedcomponents/4layouts/DetailWrapper'
import useDetailEditMode from '../../../sharedcomponents/4layouts/useDetailEditMode'
import LeftCard from '../../../sharedcomponents/5templates/detailCards/leftCard'
import ListBucketCard from '../../../sharedcomponents/5templates/detailCards/listBucketCard'
import useEntity from './useEntity'
import LeftChild from './LeftChild'

const EntityDetail = ({ createMode }) => {
  const { resourceId, type } = useParams()

  const { detailEditMode, setDetailEditMode } = useDetailEditMode(createMode)

  const {
    typeIdToDisplayName,
    useGetOneFatEntityQuery,
    fetchAuxiliaryRecords,
    bulkUpdateEntitysCallBack,
    upsertEntityCallback,
    resourceTypes,
    removeEntity,
    finalAuxiliaryRecords,
    makeInMemoryEntityRecord,
    mapToForm,
    loading: updateEntityLoading
  } = useEntity()

  const {
    data: { data: rawEntityRecord } = { data: {} },
    refetch,
    isLoading,
    isSuccess
  } = useGetOneFatEntityQuery({
      include: ['counts'],
      id: resourceId
    },
    { skip: createMode, refetchOnMountOrArgChange: true }
  )
  const primaryEntityRecord = createMode
    ? makeInMemoryEntityRecord(type)
    : JSON.parse(JSON.stringify(rawEntityRecord))

  primaryEntityRecord.refetch = refetch

  const loading = useMemo(() => updateEntityLoading || isLoading, [updateEntityLoading, isLoading])

  return (
    <DetailWrapper
      preserveEditDraft
      entityDisplayName={'Entity'}
      detailEditMode={detailEditMode}
      setDetailEditMode={setDetailEditMode}
      typeIdToDisplayName={typeIdToDisplayName}
      primaryDetailRecord={mapToForm(primaryEntityRecord)}
      isLoading={!createMode && (loading || !isSuccess)}
      secondaryDataLoaderCallBack={fetchAuxiliaryRecords}
      upsertDetailCallback={upsertEntityCallback}
      bulkUpdateCallBack={bulkUpdateEntitysCallBack}
      finalAuxiliaryRecords={finalAuxiliaryRecords}
    >
      {({ formikProps, stageActivationChange, deleteEntityCallback }) => {
        return (
          <>
            <div style={{ float: 'left', width: '34%' }}>
              <LeftCard
                entityDisplayName={'Entity'}
                formikProps={formikProps}
                editMode={detailEditMode}
                typeIdToDisplayName={typeIdToDisplayName}
                deleteEntityCallback={deleteEntityCallback(removeEntity)}
                activationChangeCallback={stageActivationChange(formikProps)}
                listOfTypes={resourceTypes}
                arrayOfBucketConfig={finalAuxiliaryRecords?.primero}
              >
                <LeftChild
                  formikProps={formikProps}
                  editMode={detailEditMode}
                  createMode={createMode}
                  entityTypes={finalAuxiliaryRecords?.entityTypes}
                  industryTypes={finalAuxiliaryRecords?.industryTypes}
                />
              </LeftCard>
            </div>
            <div style={{ float: 'left', width: '33%' }}>
              <ListBucketCard
                formikProps={formikProps}
                editMode={detailEditMode}
                arrayOfBucketConfig={finalAuxiliaryRecords?.segundo}
              />
            </div>
            <div style={{ float: 'right', width: '33%' }}>
              <ListBucketCard
                formikProps={formikProps}
                editMode={detailEditMode}
                arrayOfBucketConfig={finalAuxiliaryRecords?.tercero}
              />
            </div>
          </>
        )
      }}
    </DetailWrapper>
  )
}
export default EntityDetail
